import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import translate from "../../config/translations/translate";
import withEventTracking, { trackers } from '../../config/withEventTracking';
import ReputationTable from './reputationTable/ReputationTable'
import LocalSEOTable from './localSEOTable/localSEOTable';
import { LocalSeoStoreView } from './localSeoStoreView/LocalSeoStoreView';
import './DashboardV2Container.scss';
import DashboardPeriodSelector from './dashboardPeriodSelector/DashboardPeriodSelector';
import { DashboardStoreSelector } from './dashboardStoreSelector/DashboardStoreSelector';
import {UxSectionHeaderH3} from "botbit-ui-components";
import { LocalSEOTableIcon, ReputationTableIcon } from './DashboardV2ContainerIcons';
import { ReputationStoreView } from './reputationStoreView/ReputationStoreView';
import GlobalMetrics from './globalMetricsContainer/globalMetrics';
import ActionableSideBar from './actionablesSideBar/ActionablesSideBar'
import { GreenVerticalBarIcon, RedVerticalBarIcon, ArrowIcon } from './actionablesSideBar/ActionablesSideBarIcons';
import { getActionablesSideBarData, getActionablesSideBarDataByStoreId } from '../../api/dashboardV2Api';
import ActionableVideoModal from './actionableVideoModal/ActionableVideoModal'
import { useHistory} from 'react-router-dom';
import { callbackActionable } from '../../api/dashboardV2Api';
import { QRScansIcon } from './DashboardIcons';
import { QRScansLeaderboardModalStore } from './QrScanLeaderBoard/QRScansLeaderboardModalStore';
import { QRScansLeaderboardModalCompany } from './QrScanLeaderBoard/QRScansLeaderboardModalCompany';
import { setSelectedStoreForReviewLeaderboard } from '../../commons/components/application/applicationActions';
import { useDispatch } from 'react-redux';
import { envConfig } from '../../config/config';


//la ruta para ver este dashboard es /dashboardV2?companyId=455 por ejemplo.
const DashboardV2Container = ({t, toggleNavigationBar, navigationMenuExpanded, trackEvent}) => {
  useEffect(() => {
    window.location.href = `${envConfig.v2DashboardUrl}?companyId=${selectedCompany.id}`;
  }, []);

  const selectedCompany = useSelector(state => state.application.selectedCompany);
  const admin = useSelector(state => state.login.admin);
  const availableStores = useSelector(state => state.application.availableStores);
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState({
    value: 'LAST_30_DAYS'
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isQRScansModalOpen, setIsQRScansModalOpen] = useState(false);
  const [actionablesScoreBoardData, setActionablesScoreBoardData] = useState({});
  const [localSEOActionablesList, setLocalSEOActionablesList] = useState([]);
  const [reputationActionablesList, setReputationActionablesList] = useState([]);
  const [actionableVideoModalData, setActionableVideoModalData] = useState({
    videoURL: '',
    title: '',
    description: '',
    score: 0,
    section: '',
    executeActionable: null, 
  }); 
  const history = useHistory();
  const token = useSelector(state => state.login.token);
  const dispatch = useDispatch();

  const timePeriodOptions = [
    { value: 'LAST_30_DAYS', label: t('timePeriod.options.LAST_30_DAYS') },
    { value: 'PAST_MONTH', label: t('timePeriod.options.PAST_MONTH') },
    { value: 'LAST_3_MONTHS', label: t('timePeriod.options.LAST_3_MONTHS') },
    { value: 'LAST_6_MONTHS', label: t('timePeriod.options.LAST_6_MONTHS') },
    { value: 'LAST_12_MONTHS', label: t('timePeriod.options.LAST_12_MONTHS') },
    { value: 'THIS_YEAR', label: t('timePeriod.options.THIS_YEAR') }
  ];

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  useEffect(() => {
      const handleResize = () => {
          setWindowWidth(window.innerWidth);
      };

      window.addEventListener('resize', handleResize);
      return () => {
          window.removeEventListener('resize', handleResize);
      };
  }, []);

  useEffect(() => {
    if (windowWidth < 1100) {
      history.push('/old-dashboard');
    }
  }, [windowWidth]);

  useEffect(() => {
    if(navigationMenuExpanded) {
      toggleNavigationBar();
    }
  }, []);

  useEffect(() => {
    trackEvent('Dashboard_viewed', {
      storeId: selectedStore? selectedStore.id : null,
      companyId: selectedCompany.id,
    }, false, [trackers.MIXPANEL]);

  }, [selectedCompany, selectedStore, selectedPeriod]);

  useEffect(() => {
    const filteredStores = availableStores.filter(store => store.companyId === selectedCompany.id);
    setStores(filteredStores);
    setSelectedStore(filteredStores[0]);

  }, [availableStores, selectedCompany])


  const handleStoreChange = (event) => {
    const storeId = parseInt(event.target.value);
    const store = stores.find(store => store.id === storeId);
    
    setSelectedStore(store);
    dispatch(setSelectedStoreForReviewLeaderboard(store));
  };

  const isCompanyAccess = admin.objectAccess === "COMPANY" || admin.objectAccess === "ALL";

  const handlePeriodChange = (period) => {
    setSelectedPeriod(period);
  };

  const handleActionableExecute = async (action, url, actionableId, section) => {
    const storeId = selectedStore ? selectedStore.id : undefined;
    let updatedUrl = url.replace(`{token}`, token);
    updatedUrl = updatedUrl.replace(`{companyId}`, selectedCompany.id);
    updatedUrl = updatedUrl.replace(`{storeId}`, storeId);

    trackEvent('Dashboard_accionables_execute', {
      storeId: storeId,
      companyId: selectedCompany.id,
      actionableId: actionableId,
    }, false, [trackers.MIXPANEL]);

    if(action === "PUSH") {
      history.push(updatedUrl);
    } else if(action === "NAVIGATE") {
      window.location.replace(updatedUrl);
    } else {
      await callbackActionable(selectedCompany.id, storeId, updatedUrl); 
    }

    setIsModalOpen(false);

     // luego de ejecutarlo lo borro de la lista
    if(section === "LOCAL_SEO") {
      setLocalSEOActionablesList(prevList => {
        return prevList.filter(item => item.id !== actionableId);
      });
    } else {
      setReputationActionablesList(prevList => {
        return prevList.filter(item => item.id !== actionableId);
      });
    }
  };

  /*
    si el videoURL no es null esta función muestra el ActionableVideoModal
  */
  const actionableOpenVideoHandler =  ({videoUrl, translatedPopupTitle, translatedPopupDescription, percentageOfTotalScore, 
    feature, action, url, id}) => {
    

    return () => {
     
      if(videoUrl === null) {
        handleActionableExecute(action, url, id, feature);
        return;
      }
      
      setActionableVideoModalData({
        videoURL: videoUrl,
        title: translatedPopupTitle,
        description: translatedPopupDescription,
        score: Math.trunc(percentageOfTotalScore),
        section: feature,
        executeActionable: () => handleActionableExecute(action, url, id, feature),
      })

      setIsModalOpen(true);
    }
  }

  
  const handleQrScansRedirect = () => {
    setIsQRScansModalOpen(true);
  };


  /* 
  esta función recibe la lista entera de accionables y los separa en dos listas de acuerdo al valor de feature,
  además cambia algunos nombres de campos del objeto para que coincida con lo que espera el componente UxCallToActionList
  */
  const processActionablesData = (items) => {
    const localSEO = [];
    const reputation = [];


    items.forEach((item) => {
      
      const transformedItem = {
        title: item.translatedDescription, 
        subtitle: item.translatedLinkLabel,
        percentage: `+${Math.trunc(item.percentageOfTotalScore)}%`,
        leftIcon: item.feature === "LOCAL_SEO" ? <GreenVerticalBarIcon/> : < RedVerticalBarIcon/>,
        icon: <ArrowIcon />,
        internalRedirect: '',
        externalLink: '',
        openVideoHandler: actionableOpenVideoHandler(item), 
        ...item,
      };

      if (item.feature === "LOCAL_SEO") {
        localSEO.push(transformedItem);
      } else {
        reputation.push(transformedItem);
      }
    });

    setLocalSEOActionablesList(localSEO);
    setReputationActionablesList(reputation);
  };

  useEffect(() => {
    const fetchActionablesData = async () => {
      try {
        let response;
        if (isCompanyAccess) {
          response = await getActionablesSideBarData(selectedCompany.id, t('locale'));
        } else {
          response = await getActionablesSideBarDataByStoreId(selectedStore.id, t('locale'));
        }
        setActionablesScoreBoardData(response.data.data.scoreBoard)
        processActionablesData(response.data.data.actionables);

      } catch (error) {
        console.error("Error al obtener datos", error);
      }
    };
    if (selectedStore || isCompanyAccess) {
      fetchActionablesData();
    }
  }, [selectedStore, isCompanyAccess, selectedCompany]);

  
  return (
    <div className={`dashboard-v2-grid-container ${isCompanyAccess ? 'company-access' : 'store-access'}`}>
      <ActionableVideoModal 
        videoURL={actionableVideoModalData.videoURL}
        title={actionableVideoModalData.title}
        description={actionableVideoModalData.description}
        score={actionableVideoModalData.score}
        section={actionableVideoModalData.section}
        modalOpen={isModalOpen} 
        onCancel={() => setIsModalOpen(false)} 
        onModalClose={() => setIsModalOpen(false)}
        onCallToAction={actionableVideoModalData.executeActionable}

      />
      {isCompanyAccess ? (
        <QRScansLeaderboardModalCompany
          isOpen={isQRScansModalOpen}
          onClose={() => setIsQRScansModalOpen(false)}
          companyId={selectedCompany ? selectedCompany.id : null}
          companyName={selectedCompany ? selectedCompany.name : null}
          stores={stores}
          selectedStore={selectedStore}
          handleStoreChange={handleStoreChange}
          t={t}
        />
      ) : (
        <QRScansLeaderboardModalStore
          isOpen={isQRScansModalOpen}
          onClose={() => setIsQRScansModalOpen(false)}
          storeId={selectedStore ? selectedStore.id : null}
          storeName={selectedStore ? selectedStore.name : null}
          stores={stores}
          selectedStore={selectedStore}
          handleStoreChange={handleStoreChange}
          showStoreSelector={stores.length > 1}
          t={t}
        />
      )}
      <div className="dashboard-v2-titles-and-tables-and-charts-container">
        <div className="dashboard-v2-header-title-and-kpis-container">
            <div className="dashboard-v2-header-title-container">
              <h2>{t('dashboard.metrics.title')}</h2>
              <h2>{selectedCompany.name}</h2>
            </div>
        </div>
        
        {/* caso 1: el admin tiene acceso a la company */}
        {isCompanyAccess && stores.length > 0 && (
          <>
            <div className="dashboard-v2-global-metrics-container">
              <div className="dashboard-v2-global-metrics-header">
                <h2>{t('dashboard.globalMetrics.title')}</h2>
                <div className="dashboard-v2-global-metrics-period-selector-container">
                  <DashboardPeriodSelector 
                    timePeriodOptions={timePeriodOptions}
                    t={t}
                  selectedPeriod={selectedPeriod}
                  handlePeriodChange={handlePeriodChange}
                  setSelectedPeriod={setSelectedPeriod}
                  />
                </div>
              </div>
              <div className="dashboard-v2-global-metrics-content-container">
                <GlobalMetrics 
                  companyId={selectedCompany.id}
                  period={selectedPeriod}  
                />
              </div>
            </div>
            <div className="dashboard-v2-local-seo-table-and-title-container">
              <UxSectionHeaderH3
                icon={<LocalSEOTableIcon />}
                title={t('localSeo.title')}
                subtitle={t('localSeo.subtitle')}
                setSelectedPeriod={setSelectedPeriod}
              />
              <div className="dashboard-v2-table-and-period-selector-container">
                <div className="dashboard-v2-table-container">
                  <LocalSEOTable 
                    companyId={selectedCompany.id} 
                    period={selectedPeriod}
                    timePeriodOptions={timePeriodOptions}
                    selectedPeriod={selectedPeriod}
                    handlePeriodChange={handlePeriodChange}
                    windowWidth={windowWidth}
                  />
                </div> 
              </div> 
            </div>
            <div className="dashboard-v2-reputation-table-and-title-container">
              <div className="section-header-container">
                <UxSectionHeaderH3
                  icon={<ReputationTableIcon />}
                  title={t('reputation.title')}
                  subtitle={t('reputation.subtitle')}
                />
                
                {<button
                  onClick={handleQrScansRedirect}
                  className="qr-scans-button"
                >
                  <QRScansIcon />
                  {t('qrScans.leaderboard')}
                </button>}
              </div>
              <div className="dashboard-v2-table-and-period-selector-container">
                  
                  <div className="dashboard-v2-table-container">
                    <ReputationTable 
                      companyId={selectedCompany.id} 
                      period={selectedPeriod}
                      timePeriodOptions={timePeriodOptions}
                      selectedPeriod={selectedPeriod}
                      handlePeriodChange={handlePeriodChange}
                      windowWidth={windowWidth}
                    />
                  </div>
              </div>
            </div>
          </>
        )}

        {/* caso 2: el admin no tiene acceso a company */}
        {!isCompanyAccess && selectedStore && (
          <>
          <div className="dashboard-v2-global-metrics-container">
            <div className="dashboard-v2-global-metrics-header">
              <h2>{t('dashboard.globalMetrics.title')}</h2>
                {stores.length > 1 && (
                  <div className="dashboard-v2-global-metrics-store-selector-container">
                    <DashboardStoreSelector
                      stores={stores}
                      selectedStore={selectedStore}
                      handleStoreChange={handleStoreChange}
                      t={t}
                    />
                  </div>
                )}
                <div className="dashboard-v2-global-metrics-period-selector-container">
                  <DashboardPeriodSelector 
                    timePeriodOptions={timePeriodOptions}
                    t={t}
                    selectedPeriod={selectedPeriod}
                    handlePeriodChange={handlePeriodChange}
                    setSelectedPeriod={setSelectedPeriod}
                  />
              </div>
            </div>
            <div className="dashboard-v2-global-metrics-content-container">
              <GlobalMetrics storeId={selectedStore.id} period={selectedPeriod} />
            </div>
          </div>
          <div className="dashboard-v2-local-seo-charts-and-title-container">
            <UxSectionHeaderH3
                icon={<LocalSEOTableIcon />}
                title={t('localSeo.title')}
                subtitle={t('localSeo.subtitle')}
              />
              <div className="local-seo-store-view-and-period-selector-and-store-selector-container">
                  {/* 2.1: se agrega selector de store (solo se muestra si hay más de una tienda)*/}
                  {stores.length > 1 && (
                    <DashboardStoreSelector
                      stores={stores}
                      selectedStore={selectedStore}
                      handleStoreChange={handleStoreChange}
                      t={t}
                    />
                  )}
                  {/* 2.2: no se agrega el selector de store */}
                  {/* el selector de periodo y la vista de store es comun para 2.1 y 2.2 */}
                  <DashboardPeriodSelector 
                    timePeriodOptions={timePeriodOptions}
                    t={t}
                    selectedPeriod={selectedPeriod}
                    handlePeriodChange={handlePeriodChange}
                    setSelectedPeriod={setSelectedPeriod}
                  />
                  <div className="local-seo-store-view-container">
                    <LocalSeoStoreView 
                      store={stores.length === 1 ? stores[0] : selectedStore}
                      selectedPeriod={selectedPeriod}
                      t={t}
                    />
                  </div>
              </div>
          </div>
          <div className="dashboard-v2-local-seo-charts-and-title-container">
              <div className="section-header-container">
                <UxSectionHeaderH3
                  icon={<ReputationTableIcon />}
                  title={t('reputation.title')}
                  subtitle={t('reputation.subtitle')}
                />
                
                {<button
                  onClick={handleQrScansRedirect}
                  className="qr-scans-button"
                >
                  <QRScansIcon />
                  {t('qrScans.leaderboard')}
                </button>}
              </div>
              <div className="local-seo-store-view-and-period-selector-and-store-selector-container">
              
                    {stores.length > 1 && (
                    
                      <DashboardStoreSelector
                        stores={stores}
                        selectedStore={selectedStore}
                        handleStoreChange={handleStoreChange}
                        t={t}
                      />
                    )}
                  
                    <DashboardPeriodSelector 
                      timePeriodOptions={timePeriodOptions}
                      t={t}
                      selectedPeriod={selectedPeriod}
                      handlePeriodChange={handlePeriodChange}
                      setSelectedPeriod={setSelectedPeriod}
                    />
                
                  <div className="local-seo-store-view-container">
                    <ReputationStoreView 
                      store={stores.length === 1 ? stores[0] : selectedStore}
                      selectedPeriod={selectedPeriod}
                    />
                  </div>
              </div>
          </div>
          </>
        )}
      </div>
      
      <div className="dashboard-v2-actionables-container">
         <ActionableSideBar 
            
            localSEOScoreAchieved={Math.trunc(actionablesScoreBoardData.localSeoPercentage)}
            reputationScoreAchieved={Math.trunc(actionablesScoreBoardData.reputationPercentage)}
            localSEOActionablesList={localSEOActionablesList}
            reputationActionablesList={reputationActionablesList}
         />
      </div>
    </div>
  )
}

DashboardV2Container.translations = {
  locationSelector: {
    label: {
      es: "Selecciona una tienda",
      en: "Select a store",
    },
  },
  timePeriod: {
    label: {
      es: "Período de tiempo",
      en: "Time period",
    },
    options: {
      LAST_7_DAYS: {
        es: "Últimos 7 días",
        en: "Last 7 days",
      },
      LAST_30_DAYS: {
        es: "Últimos 30 días",
        en: "Last 30 days",
      },
      THIS_MONTH: {
        es: "Este mes",
        en: "This month",
      },
      PAST_MONTH: {
        es: "Mes pasado",
        en: "Past month",
      },
      LAST_3_MONTHS: {
        es: "Últimos 3 meses",
        en: "Last 3 months",
      },
      LAST_6_MONTHS: {
        es: "Últimos 6 meses",
        en: "Last 6 months",
      },
      LAST_12_MONTHS: {
        es: "Últimos 12 meses",
        en: "Last 12 months",
      },
      THIS_YEAR: {
        es: "Este año",
        en: "This year",
      },
    }
  },
  localSeo: {
    title: {
      es: "Que te encuentren",
      en: "Get found"
    },
    subtitle: {
      es: "Mediante tus palabras claves, puedes posicionarte en Google para que tus usuarios te encuentren primero!",
      en: "Through your keywords, you can position yourself on Google so your users find you first!"
    }
  },
  reputation: {
    title: {
      es: "Que te elijan",
      en: "Get Chosen"
    },
      subtitle: {
        es: "Qué dicen mis clientes sobre mi marca? Mejora el feedback sobre tu producto o servicio!",
        en: "What do my customers say about my brand? Improve the feedback on your product or service!"
    }
  },
  dashboard: {
    metrics: {
      title: {
        es: "Métricas de ",
        en: "Metrics for "
      },
      subtitle: {
        es: "Tus métricas globales para poder tomar acciones y posicionar tu marca.",
        en: "Your global metrics to take actions and position your brand."
      }
    },
    globalMetrics: {
      title: {
        es: "Métricas globales configuradas en base a:",
        en: "Global metrics configured based on:"
      }
    }
  },
  locale: {
    es: "es",
    en: "en"
  },
  qrScans: {
    leaderboard: {
      es: "Tabla de escaneos QR",
      en: "QR scans leaderboard"
    }
  }
}

export default withEventTracking(translate(DashboardV2Container));